<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" lg="5">
                <s-crud title="Usuarios" search-input :config="configUser" @save="save($event)"
                    @rowSelected="rowSelected($event)">
                    <template v-slot:options>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on" small elevation="0" @click="copyAllow">
                                    <v-icon color="default" x-small> fas fa-copy </v-icon>
                                </v-btn>
                            </template>
                            <span>Copiar a</span>
                        </v-tooltip>
                    </template>
                </s-crud>
            </v-col>

            <v-col v-if="item">
                <s-toolbar label="Permisos" @removed="deleteEvent()" remove excel>
                    <v-text-field lg="5" v-model="searchText" append-icon="mdi-magnify" single-line
                        hide-details></v-text-field>
                </s-toolbar>
                <v-card elevation="0">
                    <v-col>
                        <v-row justify="center">
                            <v-col lg="10" class="pb-1" cols="12">
                                <s-select-area ref="usrcce" clearable label="Centro de Costo" centercost
                                    v-model="form.CceID" :key="keyselectCceID" />
                            </v-col>
                            <v-col lg="6" class="pt-0" cols="12">

                                <s-select-business-line clearable multiple label="Linea de Negocio"
                                    :cceID="form.CceID == null ? 0 : form.CceID" v-model="form.BslID"
                                    @input="changeBusinessLine($event)" :key="keyselectBslID" />
                            </v-col>
                            <v-col lg="4" class="pt-0" cols="12">
                                <s-select-definition :def="1045" label="Tipo de Costo" v-model="form.TypeCost" />
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col class="pt-1" lg="5">
                                <v-btn @click="resetItem(); $refs.usrcce.focus();" block small>Nuevo</v-btn>
                            </v-col>
                            <v-col class="pt-1" lg="5">
                                <v-btn @click="save(item)" block small color="primary">Guardar</v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-card>

                <!-- Campo de búsqueda -->

                <!-- Data table con filtro -->
                <v-data-table show-select :items="filteredItemsPermit" dense item-key="PerID" :headers="config.headers"
                    v-model="selectedPermit" :single-select="true">
                </v-data-table>
            </v-col>
        </v-row>

        <v-dialog v-model="showDialogCopy" max-width="500">
            <v-card>
                <v-card-title>
                    <label>
                        Seleccione a quienes copiará los permisos de
                        <strong>{{ (userSelected.UsrName || "").toUpperCase() }}</strong>
                    </label>
                </v-card-title>

                <v-card-text>
                    <s-user v-model="usersCopy" ref="usrcopy" :isCrud="false" :singleRow="false" />
                </v-card-text>

                <v-card-actions>
                    <v-btn color="default" small text @click="closeDialogCopy()"> Cerrar </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="success" dark depressed small @click="saveCopyPermit()">Copiar permisos
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import _sPermit from "@/services/Logistics/PermitService";
import _sUser from "@/services/Logistics/UserService";
import sUser from "@/views/Security/UserOption/User.vue";

export default {
    components: { sUser },
    data: () => ({
        keyselectCceID: 0,
        keyselectBslID: 0,
        itemsUsers: [],
        itemsPermit: [],
        form: {
            CceID: null,
            BslID: [],
            TypeCost: 1,
        },
        item: null,
        selectedPermit: [],
        showDialogCopy: false,
        usersCopy: [],
        userSelected: {},
        searchText: "", // Nueva variable para el texto de búsqueda
        config: {
            model: { PerID: "ID", CceID: "int" },
            headers: [
                { text: "#", value: "PerID" },
                { text: "ID C.Costo", value: "CceID" },
                { text: "Centro de Costo", value: "CceName" },
                { text: "ID Linea de Negocio", value: "BslID" },
                { text: "Linea de Negocio", value: "BslName" },
                { text: "Tipo de Costo", value: "TypeCostName" },
            ],
            service: _sPermit,
        },
        configUser: {
            model: { UsrID: "ID" },
            headers: [
                { text: "ID", value: "UsrID" },
                { text: "Nombre", value: "NtpFullName" },
                { text: "Usuario", value: "UsrName" },
            ],
            service: _sUser,
        },
    }),
    watch: {
        form: {
            handler(item) {
                if (item.CceID == null || item.CceID == undefined) {
                    this.form.BslID = null;
                    this.changeBusinessLine(null)
                }
            },
            deep: true,
        },
    },
    computed: {
        // Filtrado de itemsPermit basado en el texto de búsqueda
        filteredItemsPermit() {
            if (!this.searchText) {
                return this.itemsPermit;
            }
            return this.itemsPermit.filter(
                (item) =>
                    item.CceName.toLowerCase().includes(this.searchText.toLowerCase()) ||
                    item.BslName.toLowerCase().includes(this.searchText.toLowerCase()) ||
                    item.TypeCostName.toLowerCase().includes(this.searchText.toLowerCase())
            );
        },
    },
    methods: {
        copyAllow() {
            this.showDialogCopy = true;
            this.usersCopy = [];
            this.$refs.usrcopy.refresh();
        },
        saveCopyPermit() {
            this.usersCopy = Object.assign([], this.usersCopy).filter(
                (x) => x.UsrID != this.userSelected.UsrID
            );
            _sPermit
                .copyallPermit(this.userSelected, this.usersCopy, this.$fun.getUserID())
                .then((r) => {
                    this.$fun.alert("Permisos actualizados correctamente.", "success");
                    this.closeDialogCopy();
                });
        },
        rowSelected(items) {
            if (items.length > 0) {
                this.item = items[0];
                this.item.TypeCost = 1;
                if (items.length > 0) {
                    this.userSelected = items[0];
                }
                _sPermit.byUser({ UsrID: this.item.UsrID }, this.$fun.getUserID()).then((r) => {
                    this.itemsPermit = r.data;
                });
            } else this.item = null;
        },
        deleteEvent() {
            if (this.selectedPermit.length > 0) {
                console.log(this.selectedPermit);
                this.$fun.alert("¿Está seguro de eliminar el permiso seleccionado?", "question")
                    .then((val) => {
                        if (val.value) {
                            this.deletePermit();
                        }
                    });
            }
        },
        deletePermit() {
            this.selectedPermit[0].SecStatus = 0;
            _sPermit.save(this.selectedPermit[0], this.$fun.getUserID()).then((r) => {
                if (r.status == 200) {
                    this.$fun.alert("Permiso eliminado correctamente.", "success");
                    _sPermit.byUser({ UsrID: this.item.UsrID }, this.$fun.getUserID()).then((r) => {
                        this.itemsPermit = r.data;
                    });
                } else {
                    this.$fun.alert("Error al eliminar el permiso.", "error");
                }
            });
        },
        closeDialogCopy() {
            this.showDialogCopy = false;
        },
        save() {
            if (!this.form.CceID) {
                this.$fun.alert("Falta Centro de Costo", "warning");
                return;
            }

            if (!this.form.TypeCost) {
                this.$fun.alert("Falta Tipo de Costo", "warning");
                return;
            }

            const selecteds = this.selectedBusinessLine(this.form.BslID);

            if (selecteds.length == 0) {
                this.$fun.alert("Seleccionar Linea de Negocio", "warning");
                return;
            }

            const setBusiness = new Set(this.itemsPermit.map(b => b.BslID));

            for (const x of selecteds) {
                const existe = setBusiness.has(x);
                if (existe) {
                    console.log({ filtered: this.itemsPermit.find(b => b.BslID) });
                    const filtered = this.itemsPermit.find(b => b.BslID == x && b.TypeCost == this.form.TypeCost && b.CceID == this.form.CceID);
                    if (filtered) {
                        this.$fun.alert(`Ya existe el permiso para la linea de negocio ${x} : ${filtered.BslName}`, "warning");
                        return;
                    }
                }
            }

            const valuesSave = selecteds.map((x) => ({
                CceID: this.form.CceID,
                BslID: x,
                TypeCost: this.form.TypeCost,
                UsrID: this.item.UsrID,
                SecStatus: 1,
                requestID: this.$fun.getUserID()
            }));

            let index = 0
            for (const value of valuesSave) {
                _sPermit.save(value, this.$fun.getUserID()).then((result) => {
                    if (result.status == 200) {
                        _sPermit.byUser({ UsrID: value.UsrID }, this.$fun.getUserID()).then((r) => {
                            if (r.status == 200) {
                                // console.log(r.data)
                                if (index == valuesSave.length) {
                                    this.itemsPermit = r.data;
                                    this.form.CceID = null;
                                    this.$fun.alert("Permiso guardado correctamente.", "success");
                                    this.resetItem();
                                }
                            } else {
                                this.$fun.alert("Error al guardar el permiso por usuario.", "error");
                            }
                        });

                    } else {
                        this.$fun.alert("Error al guardar el permiso.", "error");
                    }
                    index++;
                });
            }
        },

        resetItem() {
            this.form.TypeCost = 1;
            this.form.BslID = null;
            this.form.CceID = null;
            this.keyselectCceID++;
            this.keyselectBslID++;
        },

        changeBusinessLine(value) {
            if (value == null || value == undefined) {
                this.keyselectBslID++;
            }
            // console.log({ changeBusinessLine: value });
        },
        selectedBusinessLine() {
            try {
                if (typeof this.form.BslID === "string") {
                    return JSON.parse(this.form.BslID);
                }

                if (Array.isArray(this.form.BslID)) {
                    return this.form.BslID;
                }

                return [];
            } catch (e) {
                return [];
            }
        }
    },
    created() {
        // _sPermit.users(this.$fun.getUserID()).then((r) => {
        //     this.itemsUsers = r.data;
        // });
    },
    mounted() {
        console.log("permiso de allline", this.$fun.hasSpecialPermission("AllLine"));
    },
};
</script>
